//@ts-nocheck
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DragDropContext, DropResult } from "react-beautiful-dnd";
import "./style/dragList.css";
import DraggableElement from "./DraggableElement";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { _fetchTopicListing } from "../../topic/topic-redux/topic.api";
import { toast } from "sonner";
import ListItem from "./ListItem";
import { useParams } from "react-router-dom";
import {
  fetchApplicationByListData,
  fetchApplicationByStage,
  UpdateJobApplicationByList,
} from "../../../features/ApplicationData/ApplicationDataSlice";
import { useAppDispatch } from "../../../app/hooks";
import { fetchJobPipelineDetailsData } from "../../../features/pipeline/pipelineSlice";
import { useSidebarMenuHover } from "../../../context/CustomHoverContext";
import LoadingBar from "react-top-loading-bar";

const ITEMS_PER_PAGE = 25;
const DragList = ({
  sectionHeight,
  activeFilters,
  itemAssignedTo,
  hasActiveFilters,
  pipelineDragStates,
}) => {
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const scrollContainers = useRef({});
  const [apiData, setApiData] = useState({});
  const { jobId } = useParams<{ jobId: string }>();
  const { baseId } = useParams<{ baseId: string }>();
  const [currentPage, setCurrentPage] = useState(1);
  const [jobApplicationCount, setJobApplicationCount] = useState("");
  const [localStorageVersion, setLocalStorageVersion] = useState(0);
  const { isTooltipHovered } = useSidebarMenuHover();
  const loadingBarRef = useRef(null);
  const [draggingOverId, setDraggingOverId] = useState(null);

  const dispatch = useAppDispatch();
  const [paginationState, setPaginationState] = useState({});

  const getListsFromLocalStorage = () => {
    try {
      // const savedData = localStorage.getItem("jobPipelineStageData")
      // const savedData = localStorage.getItem("JobPipelineDetailsData")

      let reportData = {
        stagesByBucket: {
          inbox: { name: "inbox", currentCount: 0, stages: [] },
          screening: { name: "screening", currentCount: 0, stages: [] },
          hired: { name: "hired", currentCount: 0, stages: [] },
          reject: { name: "reject", currentCount: 0, stages: [] },
        },
      };

      const storedPipelineData = localStorage.getItem("JobPipelineDetailsData");
      if (storedPipelineData) {
        const parsedPipelineData = JSON.parse(storedPipelineData);
        reportData = parsedPipelineData;
      }

      const savedData = Object.values(reportData?.stagesByBucket).flatMap(
        (bucket) => bucket.stages || [],
      );
      const sortedStages = [...savedData].sort((a, b) => a.order - b.order);
      const dataToUse = sortedStages || JSON.stringify(pipelineDragStates);

      // if (!dataToUse) {
      //   throw new Error("No saved data found in local storage");
      // }
      // const parsedData = typeof dataToUse === 'string' ? JSON.parse(dataToUse) : dataToUse;

      // if (!parsedData?.stages || !Array.isArray(parsedData.stages)) {
      //   throw new Error("Invalid data structure in local storage");
      // }

      const statusMap = new Map();
      const idMap = new Map();
      // parsedData.stages.forEach(item => {
      dataToUse.forEach((item) => {
        statusMap.set(item.stage_name, {
          title: item.stage_name,
          color: item.stage_colour,
          count: item.applications,
        });
        idMap.set(item.stage_name, item.id);
      });

      const statusList = Array.from(statusMap.values());

      return { lists: statusList, statusIdMap: idMap };
    } catch (error) {
      console.error("Error loading status titles from local storage:", error);
      return { lists: [], statusIdMap: new Map() };
    }
  };
  const { lists, statusIdMap } = useMemo(() => {
    return getListsFromLocalStorage();
  }, [localStorageVersion, pipelineDragStates]);

  const [isHovered, setIsHovered] = useState(
    lists.reduce((acc, listKey) => ({ ...acc, [listKey]: false }), {}),
  );

  const handleMouseOver = (listKey) => {
    setIsHovered((prev) => ({ ...prev, [listKey]: true }));
  };

  const handleMouseOut = (listKey) => {
    setIsHovered((prev) => ({ ...prev, [listKey]: false }));
  };

  // const prepareFilters = (activeFilters) => {
  //   const filters = {};

  //   Object.keys(activeFilters).forEach((filterType) => {
  //     if (activeFilters[filterType] && activeFilters[filterType].length > 0) {
  //       if (filterType === 'sentiment') {
  //         filters[key] = activeFilters[filterType].map(item => item.value).join(',');
  //       } else {
  //         filters[key] = activeFilters[filterType].map(item => item.id).join(',');
  //       }
  //     }
  //   });

  //   return filters;
  // };

  const prepareFilters = (activeFilters) => {
    const filters = {};

    // Handle all filter types
    Object.keys(activeFilters).forEach((filterType) => {
      if (activeFilters[filterType] && activeFilters[filterType].length > 0) {
        if (filterType === "sentiment") {
          filters[filterType] = activeFilters[filterType]
            .map((item) => item.value)
            .join(",");
        } else if (filterType === "Sort" && activeFilters[filterType][0]) {
          // Handle sorting differently
          // filters['orderingKey'] = 'created_at'; // Default key for sorting
          // Determine the ordering key based on the sort value
          const sortValue = activeFilters[filterType][0].value;

          if (sortValue.includes("Updated")) {
            filters["orderingKey"] = "updated_at";
          } else {
            filters["orderingKey"] = "created_at";
          }
          filters["order"] = activeFilters[filterType][0].value.includes(
            "first",
          )
            ? "asc"
            : "desc";
        } else if (filterType === "pagination") {
          // Handle pagination
          const { pageIndex, pageSize } = activeFilters[filterType];
          filters["page"] = pageIndex + 1; // Adjust for 0-based index
          filters["limit"] = pageSize;
        } else if (filterType === "search" && activeFilters[filterType]) {
          // Handle search term
          filters["search"] = activeFilters[filterType];
        } else {
          // Handle other filters like Stages, Updated By, etc.
          filters[filterType] = activeFilters[filterType]
            .map((item) => item.id)
            .join(",");
        }
      }
    });

    return filters;
  };

  // topic list api
  useEffect(() => {
    const fetchData = async () => {
      setInitialLoading(true);
      loadingBarRef.current.continuousStart();
      const newApiData = {};
      const newPaginationState = {};
      const filterParams = activeFilters ? prepareFilters(activeFilters) : {};

      try {
        const response = await dispatch(
          fetchApplicationByStage({
            baseId: baseId,
            jobId: jobId,
            filters: filterParams,
          }),
        ).unwrap();

        if (response?.data?.groupedByStage) {
          lists.forEach((listItem) => {
            const stageId = statusIdMap.get(listItem.title);
            const stageData = response.data.groupedByStage[stageId];
            const totalItems = stageData?.applications || 0;

            newApiData[listItem.title] = {
              items: stageData?.jobApplications || [],
              total: totalItems,
            };
            // Initialize pagination state for each list
            newPaginationState[listItem.title] = {
              currentPage: 1,
              hasNextPage: totalItems > ITEMS_PER_PAGE,
              totalPages: Math.ceil(totalItems / ITEMS_PER_PAGE),
            };
          });
        }
      } catch (error) {
        console.error("Error fetching applications:", error);
        toast.error(error || "Failed to fetch applications");
      }

      setApiData(newApiData);
      setPaginationState(newPaginationState);
      setInitialLoading(false);
      loadingBarRef.current.complete();
    };

    fetchData();
  }, [dispatch, baseId, jobId, lists, statusIdMap, activeFilters]);

  // const onDragEnd = useCallback(
  //   (result: DropResult) => {
  //     if (!result.destination) {
  //       return;
  //     }

  //     const sourceList = apiData[result.source.droppableId]?.items;
  //     const destList = apiData[result.destination.droppableId]?.items;

  //     if (!Array.isArray(sourceList) || !Array.isArray(destList)) {
  //       console.error('Source or destination list is not an array');
  //       return;
  //     }

  //     const [removed] = sourceList.splice(result.source.index, 1);
  //     destList.splice(result.destination.index, 0, removed);

  //     setApiData({
  //       ...apiData,
  //       [result.source.droppableId]: {
  //         ...apiData[result.source.droppableId],
  //         items: sourceList,
  //       },
  //       [result.destination.droppableId]: {
  //         ...apiData[result.destination.droppableId],
  //         items: destList,
  //       },
  //     });
  //   },
  //   [apiData]
  // );

  // update change status with drag and drop

  const loadMoreItems = useCallback(
    async (listKey: string) => {
      if (loading || !paginationState[listKey]?.hasNextPage) {
        return;
      }

      setLoading(true);
      const currentPage = paginationState[listKey].currentPage;
      const stageId = statusIdMap.get(listKey);

      // Prepare filter parameters
      const filterParams = activeFilters ? prepareFilters(activeFilters) : {};
      // Override the page number for pagination
      filterParams.page = currentPage + 1;
      filterParams.limit = ITEMS_PER_PAGE;

      try {
        const response = await dispatch(
          fetchApplicationByListData({
            baseId,
            jobId,
            stageId,
            page: currentPage + 1,
            limit: ITEMS_PER_PAGE,
            filters: filterParams,
          }),
        ).unwrap();

        if (response?.data?.jobApplication) {
          const existingItems = apiData[listKey]?.items || [];
          const newItems = response.data.jobApplication.filter(
            (newItem) =>
              !existingItems.some(
                (existingItem) => existingItem.id === newItem.id,
              ),
          );

          // Only update if we have new items
          if (newItems.length > 0) {
            setApiData((prev) => ({
              ...prev,
              [listKey]: {
                ...prev[listKey],
                items: [...existingItems, ...newItems],
                total: prev[listKey].total,
              },
            }));
          }

          // Update pagination state
          setPaginationState((prev) => ({
            ...prev,
            [listKey]: {
              ...prev[listKey],
              currentPage: currentPage + 1,
              hasNextPage:
                newItems.length === ITEMS_PER_PAGE &&
                existingItems.length + newItems.length < prev[listKey].total,
            },
          }));
        }
      } catch (error) {
        console.error(`Error loading more items for ${listKey}:`, error);
        toast.error("Failed to load more items");
      } finally {
        setLoading(false);
      }
    },
    [
      loading,
      paginationState,
      apiData,
      dispatch,
      baseId,
      jobId,
      statusIdMap,
      activeFilters,
    ],
  );

  const handleScroll = useCallback(
    (listItem) => {
      const container = scrollContainers.current[listItem.title];
      if (container) {
        const scrollPosition = container.scrollTop + container.clientHeight;
        const scrollThreshold = container.scrollHeight - 200;

        if (
          scrollPosition >= scrollThreshold &&
          !loading &&
          paginationState[listItem.title]?.hasNextPage
        ) {
          loadMoreItems(listItem.title);
        }
      }
    },
    [loading, loadMoreItems, paginationState],
  );

  useEffect(() => {
    const listeners = {};
    lists.forEach((listItem) => {
      const container = scrollContainers.current[listItem.title];
      if (container) {
        const handleScrollWrapper = () => handleScroll(listItem);
        container.addEventListener("scroll", handleScrollWrapper);
        listeners[listItem.title] = handleScrollWrapper;
      }
    });

    return () => {
      lists.forEach((listItem) => {
        const container = scrollContainers.current[listItem.title];
        if (container && listeners[listItem.title]) {
          container.removeEventListener("scroll", listeners[listItem.title]);
        }
      });
    };
  }, [lists, handleScroll]);

  // const onDragEnd = useCallback(
  //   async (result: DropResult) => {
  //     if (!result.destination) return;

  //     const sourceList = apiData[result.source.droppableId]?.items;
  //     const destList = apiData[result.destination.droppableId]?.items;

  //     if (!Array.isArray(sourceList) || !Array.isArray(destList)) {
  //       console.error("Source or destination list is not an array");
  //       return;
  //     }

  //     const newSourceList = [...sourceList];
  //     const newDestList = [...destList];

  //     const [removed] = newSourceList.splice(result.source.index, 1);
  //     newDestList.splice(result.destination.index, 0, removed);

  //     const originalApiData = { ...apiData };
  //     setApiData((prev) => ({
  //       ...prev,
  //       [result.source.droppableId]: {
  //         ...prev[result.source.droppableId],
  //         items: newSourceList,
  //       },
  //       [result.destination.droppableId]: {
  //         ...prev[result.destination.droppableId],
  //         items: newDestList,
  //       },
  //     }));

  //     const destinationStageId = statusIdMap.get(
  //       result.destination.droppableId,
  //     );
  //     const sourceStageId = statusIdMap.get(result.source.droppableId);

  //     try {
  //       const response = await dispatch(
  //         UpdateJobApplicationByList({
  //           baseId,
  //           applicationId: removed.id,
  //           stage_id: destinationStageId,
  //         }),
  //       ).unwrap();

  //       if (response.status !== 200) {
  //         setApiData(originalApiData);
  //         toast.error("Failed to update stage");
  //       } else {
  //         updateLocalStorageStages(sourceStageId, destinationStageId);
  //         toast.success("Stage updated successfully");
  //       }
  //     } catch (error) {
  //       setApiData(originalApiData);
  //       console.error("Update failed:", error);
  //       toast.error("Failed to update stage");
  //     }
  //   },
  //   [apiData, statusIdMap, dispatch, baseId],
  // );

  const onDragStart = useCallback((start) => {
    // Optional: Highlight the column the item is dragged FROM initially
    setDraggingOverId(start.source.droppableId);
  }, []);

  const onDragUpdate = useCallback((update) => {
    // If hovering over a valid destination column, set its ID
    if (update.destination) {
      setDraggingOverId(update.destination.droppableId);
    } else {
      setDraggingOverId(null);
    }
  }, []);

  const onDragEnd = useCallback(
    async (result: DropResult) => {
      setDraggingOverId(null);

      const { source, destination } = result;

      // If dropped outside the list entirely
      if (!destination) return;

      //  If dropped in the exact same place (no movement)
      if (
        source.droppableId === destination.droppableId &&
        source.index === destination.index
      ) {
        return;
      }

      const sourceList = apiData[source.droppableId]?.items;
      const destList = apiData[destination.droppableId]?.items;

      if (!Array.isArray(sourceList) || !Array.isArray(destList)) {
        console.error("Source or destination list is not an array");
        return;
      }

      const originalApiData = { ...apiData };

      //  Handle moving within the SAME column (Reordering)
      if (source.droppableId === destination.droppableId) {
        // Only make ONE copy of the array since source and dest are the same
        const newItems = [...sourceList];
        const [removed] = newItems.splice(source.index, 1);
        newItems.splice(destination.index, 0, removed);

        // Optimistic UI update for same column
        setApiData((prev) => ({
          ...prev,
          [source.droppableId]: {
            ...prev[source.droppableId],
            items: newItems,
          },
        }));

        // Return early since the stage hasn't changed.
        // (Note: If your backend needs to save the new order index, you would make that API call here).
        return;
      }

      //  Handle moving between DIFFERENT columns
      const newSourceList = [...sourceList];
      const newDestList = [...destList];

      const [removed] = newSourceList.splice(source.index, 1);
      newDestList.splice(destination.index, 0, removed);

      // Optimistic UI update for different columns
      setApiData((prev) => ({
        ...prev,
        [source.droppableId]: {
          ...prev[source.droppableId],
          items: newSourceList,
        },
        [destination.droppableId]: {
          ...prev[destination.droppableId],
          items: newDestList,
        },
      }));

      const destinationStageId = statusIdMap.get(destination.droppableId);
      const sourceStageId = statusIdMap.get(source.droppableId);

      try {
        const response = await dispatch(
          UpdateJobApplicationByList({
            baseId,
            applicationId: removed.id,
            stage_id: destinationStageId,
          }),
        ).unwrap();

        if (response.status !== 200) {
          // Rollback if API update fails
          setApiData(originalApiData);
          toast.error("Failed to update stage");
        } else {
          // Minimal local storage update
          updateLocalStorageStages(sourceStageId, destinationStageId);
          toast.success("Stage updated successfully");
        }
      } catch (error) {
        // Rollback on error
        setApiData(originalApiData);
        console.error("Update failed:", error);
        toast.error("Failed to update stage");
      }
    },
    [apiData, statusIdMap, dispatch, baseId],
  );

  // After successful API update
  const updateLocalStorageStages = (
    sourceStageId: number,
    destStageId: number,
  ) => {
    const savedData = localStorage.getItem("jobPipelineStageData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);

      parsedData.stages = parsedData.stages.map((stage) => {
        if (stage.id === sourceStageId) {
          stage.applications -= 1;
        }
        if (stage.id === destStageId) {
          stage.applications += 1;
        }
        return stage;
      });

      localStorage.setItem("jobPipelineStageData", JSON.stringify(parsedData));
    }
  };

  // const onDragEnd = useCallback(

  //   async (result: DropResult) => {
  //     if (!result.destination) {
  //       return;
  //     }

  //     const sourceList = apiData[result.source.droppableId]?.items;
  //     const destList = apiData[result.destination.droppableId]?.items;

  //     if (!Array.isArray(sourceList) || !Array.isArray(destList)) {
  //       console.error('Source or destination list is not an array');
  //       return;
  //     }

  //     const [removed] = sourceList.splice(result.source.index, 1);
  //     destList.splice(result.destination.index, 0, removed);

  //     setApiData({
  //       ...apiData,
  //       [result.source.droppableId]: {
  //         ...apiData[result.source.droppableId],
  //         items: sourceList,
  //       },
  //       [result.destination.droppableId]: {
  //         ...apiData[result.destination.droppableId],
  //         items: destList,
  //       },
  //     });

  //     const updatedItem = {
  //       stage_id: statusIdMap.get(result.destination.droppableId),
  //     };
  //     const destinationStageId = statusIdMap.get(result.destination.droppableId);

  //     try {
  //       const response = await dispatch(UpdateJobApplicationByList({
  //         baseId,
  //         applicationId: removed.id,
  //         stage_id: destinationStageId
  //       })).unwrap();

  //       if (response.status === 200) {
  //         toast.success('Stage update successfully');
  //         if (jobId && baseId) {
  //           try {
  //             const res = await dispatch(fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId })).unwrap()
  //             localStorage.setItem('jobPipelineStageData', JSON.stringify(res?.data));
  //             setLocalStorageVersion(prev => prev + 1);
  //           } catch (error) {
  //             console.error("Error fetching document:", error);
  //           }
  //         }
  //       }
  //     } catch (error) {
  //       console.error('Update failed:', error);
  //     }
  //   },
  //   [apiData, statusIdMap]
  // );

  useEffect(() => {
    const applyStyles = () => {
      const tableElement = document.querySelector(
        ".feedback-col",
      ) as HTMLElement | null;
      const tableElement1 = document.querySelector(
        ".feedback-thead",
      ) as HTMLElement | null;
      const isTabScreen = window.matchMedia("(max-width: 1499px)").matches;
      const isSmallScreen = window.matchMedia("(max-width: 767px)").matches;
      if (tableElement) {
        if (isSmallScreen) {
          tableElement.style.marginTop = sectionHeight
            ? `calc(50px + ${sectionHeight}px)`
            : "50px";
        } else if (isTabScreen) {
          tableElement.style.marginTop = sectionHeight
            ? `calc(15px + ${sectionHeight}px)`
            : "46px";
        } else {
          tableElement.style.marginTop = sectionHeight
            ? `calc(15px + ${sectionHeight}px)`
            : "45px";
        }
      }

      if (tableElement1) {
        if (isSmallScreen) {
          tableElement1.style.top = sectionHeight
            ? `calc(80px + ${sectionHeight}px)`
            : "80px";
        } else if (isTabScreen) {
          tableElement1.style.top = sectionHeight
            ? `calc(101px + ${sectionHeight}px)`
            : "101px";
        } else {
          tableElement1.style.top = sectionHeight
            ? `calc(101px + ${sectionHeight}px)`
            : "101px";
        }

        if (sectionHeight) {
          tableElement1.style.borderTop = "1px solid #e5e7eb";
        } else {
          tableElement1.style.borderTop = "none";
        }
      }
    };

    applyStyles();
    window.addEventListener("resize", applyStyles);
    return () => {
      window.removeEventListener("resize", applyStyles);
    };
  }, [sectionHeight]);

  return (
    <div
      className="!pt-[0px] flex-1 feedback-col bg-white overflow-hidden rounded-br-lg"
      style={{
        borderBottom: "1px solid #e0e0e0d9",
        borderRight: "1px solid #e0e0e0d9",
      }}
    >
      <LoadingBar color="#ff591e" ref={loadingBarRef} />
      <div
        className="drag-list-container feedback-thead px-[15px] overflow-x-auto whitespace-nowrap"
        style={{
          display: "flex",
          flexDirection: "row",
          overflowX: "auto",
          width: "100%",
          paddingBottom: "10px",
          scrollbarWidth: "thin",
          height: hasActiveFilters
            ? "calc(100vh - 108px)"
            : "calc(100vh - 108px)",
        }}
      >
        <DragDropContext
          onDragEnd={onDragEnd}
          onDragStart={onDragStart}
          onDragUpdate={onDragUpdate}
        >
          {lists.map((listItem) => (
            <div
              key={listItem.title}
              className={`kanban-list-overflow overflowing-element drag-container rounded-[0.25rem] min-w-[320px] w-[320px] px-[1rem] flex flex-col flex-1 pb-[0.5rem]
                transition-all duration-200 ease-in-out
                 ${isHovered[listItem.title] ? "hovered" : ""}
               
                 `}
              //  ${draggingOverId === listItem.title ? `border-2 bt-2 border-dashed border-[${listItem.color}] bg-[${listItem.color}]-50/50` : `border-2 border-transparent`}
              onMouseOver={() => handleMouseOver(listItem.title)}
              onMouseOut={() => handleMouseOut(listItem.title)}
              ref={(el) => (scrollContainers.current[listItem.title] = el)}
            >
              <div
                className="flex items-center justify-between h-[52px] min-h-[52px] sticky top-[0px] left-0 kanban-listing-main bg-white"
                style={{
                  zIndex: 1,
                  // background: isTooltipHovered ? 'transparent' : 'white'
                }}
              >
                <div className="flex items-center max-w-full font-[500] leading-[1.2] text-[0.75rem] px-[0rem] py-[5px] gap-[0.5rem]">
                  <span
                    style={{ background: `${listItem.color}` }}
                    className={`flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-[2px] text-[0.625rem] font-medium text-white 
    capitalize`}
                  ></span>

                  <span className="text-dark-black-100 capitalize text-[13px]">
                    {listItem.title}
                  </span>
                  <span className="text-dark-black-200 text-[0.8125rem] font-normal">
                    {listItem.count}
                  </span>
                </div>
                {/* <div className='flex items-center text-start  leading-[1rem] flex-1 max-w-[50px] text-dark-black-200 justify-end [&>button]:w-auto  [&>button]:bg-transparent  [&>button]:hover:bg-transparent'>
          <MenuDropdown groups={dropdownGroups} image={
            <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>
            </svg>
          } />
        </div> */}
              </div>
              <div
                className={`flex-1 flex flex-col transition-all duration-200 ease-in-out rounded-[0.25rem] ${
                  draggingOverId === listItem.title
                    ? "border-2 border-dashed"
                    : "border-2 border-transparent"
                }`}
                style={{
                  // Use inline styles to safely apply dynamic hex colors
                  borderColor:
                    draggingOverId === listItem.title
                      ? listItem.color
                      : "transparent",
                  // Append '1A' to a hex code to give it a 10% opacity background tint
                  backgroundColor:
                    draggingOverId === listItem.title
                      ? `${listItem.color}1A`
                      : "transparent",
                }}
              >
                {initialLoading ? (
                  <div className="skeleton-wrapper rounded-[0.25rem] min-w-[280px] w-[320px] px-[0rem] flex flex-col flex-1 pb-[0.5rem] bg-[#fff]">
                    {Array.from({ length: 1 }).map((_, index) => (
                      <div
                        key={index}
                        className="  p-4 bg-gray-50 rounded-lg max-w-xs w-full h-20"
                      >
                        <Skeleton circle={true} height={30} width={30} />
                        <div className="skeleton-details">
                          {/* <Skeleton width={`80%`} height={`10px`} /> */}
                          <Skeleton width={`60%`} height={`10px`} />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <DraggableElement
                    elements={apiData[listItem.title]?.items || []}
                    prefix={listItem}
                    initialLoading={initialLoading}
                  />
                )}
              </div>
              {apiData[listItem.title]?.hasNextPage && loading && (
                <div className="skeleton-wrapper rounded-[0.25rem] min-w-[280px] w-[320px] px-[1rem] flex flex-col flex-1 pb-[0.5rem] bg-[#fff]">
                  {Array.from({ length: 1 }).map((_, index) => (
                    <div
                      key={index}
                      className="p-4 rounded-lg bg-gray-50 max-w-xs w-full h-28"
                    >
                      <Skeleton circle={true} height={30} width={30} />
                      <div className="skeleton-details">
                        <Skeleton width={`80%`} height={`10px`} />
                        <Skeleton width={`60%`} height={`10px`} />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </DragDropContext>
      </div>
    </div>
  );
};

export default DragList;
